import sys_monitor_log_ope_list from './log-opelist';
import sys_monitor_log_login_list from './log-loginlist';

export default {
    sys_monitor_log_ope_list,
    sys_monitor_log_login_list,
};
